import { render, staticRenderFns } from "./emailSendBox.vue?vue&type=template&id=1318d96b&scoped=true"
import script from "./emailSendBox.vue?vue&type=script&lang=js"
export * from "./emailSendBox.vue?vue&type=script&lang=js"
import style0 from "./emailSendBox.vue?vue&type=style&index=0&id=1318d96b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1318d96b",
  null
  
)

export default component.exports